export default "__VITE_ASSET__TWplKw8a__"